import { Outlet, createRootRoute } from "@tanstack/react-router"
import React, { Suspense } from "react"

import DemoBanner from "@/components/Common/DemoBanner"
import ErrorView from "@/components/Common/ErrorView"
import NotFound from "@/components/Common/NotFound"
import { Toaster } from "@/components/ui/toaster"
import { SidebarProvider } from "@/contexts/SidebarContext"

const loadDevtools = () =>
  Promise.all([
    import("@tanstack/router-devtools"),
    import("@tanstack/react-query-devtools"),
  ]).then(([routerDevtools, reactQueryDevtools]) => {
    return {
      default: () => (
        <>
          <routerDevtools.TanStackRouterDevtools />
          <reactQueryDevtools.ReactQueryDevtools />
        </>
      ),
    }
  })

const TanStackDevtools =
  process.env.NODE_ENV === "production" ? () => null : React.lazy(loadDevtools)

export const Route = createRootRoute({
  component: () => (
    <SidebarProvider>
      {/* OrganizationProvider is intentionally NOT mounted here. It calls
          useAuth(), whose currentUser query + "any error → drop token and
          redirect to /login" effect must never run on public routes. Mounting
          it at the root made those authed queries fire during the two-step
          (password → 2SV code) login window, where the user holds only a
          half-authenticated MFA challenge and not a session token; the
          resulting 401s wiped the freshly-minted token and forced a second
          full login. The provider now lives inside _layout (authenticated
          area only) — see routes/_layout.tsx. The demo path mints a real
          visitor token and renders inside _layout, so it is unaffected. */}
      {/* Banner mounts here (not in _layout) so that it surfaces on
          /login and every other public route too — operators flipping
          demo mode ON should see the indicator everywhere, not only on
          authenticated pages. */}
      <DemoBanner />
      <Outlet />
      <Toaster />
      <Suspense>
        <TanStackDevtools />
      </Suspense>
    </SidebarProvider>
  ),
  notFoundComponent: () => <NotFound />,
  errorComponent: () => <ErrorView />,
})
